var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('fieldset', [_c('legend', [_vm._v("User to client mapping")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-md-12 "
  }, [_c('div', {
    staticClass: "col-md-2 float-md-left "
  }, [_c('label', [_vm._v("Client Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 float-md-left "
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isallclient),
      expression: "isallclient"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.client && _vm.client.length > 0 ? '' : 'required'),
      expression: "client && client.length > 0 ? '':'required'"
    }],
    class: {
      'error': _vm.errors.has(_vm.isallclient)
    },
    attrs: {
      "id": "isallclient",
      "disabled": _vm.allCheckDisabled,
      "type": "checkbox",
      "name": "isallclient"
    },
    domProps: {
      "value": _vm.isallclient,
      "checked": Array.isArray(_vm.isallclient) ? _vm._i(_vm.isallclient, _vm.isallclient) > -1 : (_vm.isallclient)
    },
    on: {
      "click": function($event) {
        _vm.setAllClient($event)
      },
      "__c": function($event) {
        var $$a = _vm.isallclient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.isallclient,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isallclient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isallclient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isallclient = $$c
        }
      }
    }
  }), _vm._v(" IsAllClient"), _c('br')]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('isallclient')),
      expression: "errors.has('isallclient')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select all client option.\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 float-md-left"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isallclient == false ? 'required' : ''),
      expression: "isallclient ==false ? 'required' : ''"
    }],
    class: {
      'error': _vm.errors.has(_vm.client)
    },
    attrs: {
      "name": "client",
      "id": "client",
      "disabled": _vm.isDisabled,
      "selected": _vm.listclientdata,
      "options": _vm.clientList,
      "multiple": true,
      "placeholder": "Type to search",
      "track-by": "CompanyName",
      "label": "CompanyName"
    },
    on: {
      "input": _vm.updateValueAction
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  }, [_c('span', {
    slot: "noResult"
  }, [_vm._v("Oops! No client found...")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('client')),
      expression: "errors.has('client')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select clients from options.\n                    ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "userfooter form-actions"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "size": "vlg"
    }
  }, [_vm._v("Save")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "vlg"
    },
    on: {
      "click": _vm.closeRegistration
    }
  }, [_vm._v("Cancel")])])])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444d8a2a","hasScoped":true}!./src/views/components/userclientmap/userclientmap.component.html
// module id = 847
// module chunks = 1